// CommentsAddInput.jsx

import React, { forwardRef } from 'react';

// Context
import { useUser } from 'context/UserContext';

// CSS
import './CommentsAddInput.css';

// Components
import CommentsEmojiSelector from './emojis/CommentsEmojiSelector';
import TextInput from 'components/textinput/TextInput';

/**
 * CommentsAddInput
 *
 * @returns {ReactNode} The rendered component.
 */
const CommentsAddInput = forwardRef(({
    allowAnonymous = false,
    newComment,
    onFocus,
    onChange,
    placeholder,
    hybrid = true,
    emojiSelectorVisible,
    onEmojiClick,
    reserveButtonSpace = true,
}, ref) => {

    // User Context

    const { user } = useUser();

    if (!user && !allowAnonymous) return null;

    /**
 * Handles change.
 *
 * @param {*} e
 */
    const handleChange = (e) => {
        onChange(e.target.value);
    };

    /**
 * Handles focus.
 *
 * @param {*} e
 */
    const handleFocus = (e) => {
        if (onFocus) onFocus(e);
    };
    return (

        <div className="comments-add-input-container">

            <TextInput
              style={{
                    //fontSize: '16px',
                    resize: 'none',
                    overflow: 'hidden',
                    minHeight: '45px',
                    //color: theme.foreground,
                    ...(reserveButtonSpace ? { paddingRight: '50px' } : { paddingRight: '16px' }),
                    maxHeight: '200px',
                }}
              ref={ref}
              name="comment"
              placeholder={placeholder}
              value={newComment}
              multiline
              expandable
              rows={1}
              aria-label="Comment"
              hybrid={hybrid}
              onChange={handleChange}
              onFocus={handleFocus}
            />

            {emojiSelectorVisible && (
                <CommentsEmojiSelector onEmojiClick={onEmojiClick} />
            )}

        </div>

    );
});

// Dev Tools
CommentsAddInput.displayName = 'CommentsAddInput';

export default CommentsAddInput;
